import { HttpResponseException } from './exceptions/HttpResponseException';
export const MFA = 'mfa_error';
export const isResponseError = (error) => error instanceof HttpResponseException;
export const isResponseErrorOfStatus = (error, status) => isResponseError(error) && error.status === status;
